module.exports = __webpack_public_path__ + "static/media/high-five-kitten.d1f5a59a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/high-five-kitten.jpg
// module id = 289
// module chunks = 0